/**
 * Local-only "I am this resource" mapping. The backend has no staff_user →
 * resource_id link yet, so the Me page lets the user pick once per device
 * and stores the choice in localStorage. Scoped per tenant slug.
 */

const KEY_PREFIX = "calendar.me-resource.";

export function getMyResourceId(tenantSlug: string): string | null {
  if (typeof localStorage === "undefined") return null;
  return localStorage.getItem(`${KEY_PREFIX}${tenantSlug}`);
}

export function setMyResourceId(tenantSlug: string, resourceId: string | null): void {
  if (typeof localStorage === "undefined") return;
  if (resourceId) localStorage.setItem(`${KEY_PREFIX}${tenantSlug}`, resourceId);
  else localStorage.removeItem(`${KEY_PREFIX}${tenantSlug}`);
}
